import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../../common/Dropdown'
import CampaignMenu from '../CampaignMenu.js'

import { UserDataContext } from "../../../App.js";

function RulesMenuPDF(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];
    const setRule = props.setRule;

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));


    let menuOptions = [
            'Magic Items Table',
            'Scrolls',
            'Magic Rings',
            'Rods Staffs Wands',
            'Miscellaneous Magic',
            'Armor and Weapons',
            'All Magic Items'
            // ...(userData.loggedIn ? ['View > DM'] : []),
          ];

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    const handleMenu = async (selection) => {
        // Implement the various menu options here

        let Img;
        let imgSet = false;

        menuOptions.forEach((option, i) => {

            if ( menuOptions[selection] === option ) {
            Img = require(`../../../pdf/magicItems/${option}.pdf`)
            
            imgSet = true;
        }
        });

        // DISPLAY IMAGE IN WINDOW (if set)
        if ( imgSet ) {
            window.open(Img, '_blank').focus();
        }


    } // end of HANDLE FUNCTION


    // ------------  Return JSX  ----------------
    
    return (
    
        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">PDFs</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'discord-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default RulesMenuPDF